<template>
  <label v-if="label" class="form-label" :for="name">
    {{ label }}
    <span v-if="required" class="text-danger">*</span>
    <slot name="label_appends"></slot>
  </label>
  <div class="input-group">
    <span v-if="isPriceValue" class="input-group-text">
      {{ currencySymbol }}
    </span>
    <input
      v-model="model"
      :step="step"
      type="number"
      class="form-control"
      :style="
        readonly
          ? 'cursor: not-allowed; -webkit-appearance: none; -moz-appearance: textfield;'
          : ''
      "
      :class="[readonly ? 'bg-gray' : '', error ? 'is-invalid' : '']"
      :name="name"
      :placeholder="placeholder"
      :disabled="disabled"
      :required="required"
      :readonly="readonly"
    />
  </div>
  <span v-if="error" class="mt-2 text-sm text-red-600">{{ error }}</span>
</template>

<script setup>
import "@vuepic/vue-datepicker/dist/main.css";
import { computed } from "vue";

defineEmits(["cleared", "updated"]);

const props = defineProps({
  label: {
    type: String,
    default: null,
  },
  isPriceValue: {
    type: Boolean,
    default: false,
  },
  currencySymbol: {
    type: String,
    default: "£",
  },
  placeholder: {
    type: String,
    default: null,
  },
  required: {
    type: Boolean,
    required: false,
  },
  readonly: {
    type: Boolean,
    required: false,
  },
  error: {
    type: [Boolean, String],
    required: false,
  },
  step: {
    type: Number,
    default: 1,
  },
  name: {
    type: String,
    required: true,
  },
  timePicker: {
    type: Boolean,
    default: false,
  },
  isMinorValue: {
    type: Boolean,
    default: true,
  },
  disabled: {
    type: [Boolean, String],
    default: false,
  },
});

const disabled = computed(() => {
  return props.disabled || props.readonly;
});

const model = defineModel({
  type: [Number, String],
  default: null,
  get: (value) => {
    if (!props.isPriceValue) {
      return value;
    }
    return props.isMinorValue
      ? parseFloat(value).toFixed(2)
      : parseFloat(value / 100).toFixed(2);
  },
});
</script>

<style></style>
